<template>
  <div class="page">
    <div class="searchBox">
      <el-row>
        <el-col :span="8">
          <div style="color: #f5882a; font-size: 12px; line-height: 33px">
            <i
              @click="syncStaff"
              class="el-icon-refresh"
              style="width: 20px; height: 20px; cursor: pointer"
            ></i>
            <span @click="syncStaff" style="cursor: pointer">刷新员工</span>
          </div>
        </el-col>
        <el-col :span="10">
          <div>
            <el-date-picker
              style="width: 130px; margin-left: 10px"
              size="mini"
              v-model="currDate"
              type="month"
              value-format="yyyy-M"
              placeholder="选择日期"
              @change="changePicker"
            >
            </el-date-picker>
          </div>
        </el-col>
        <el-col :span="6">
          <el-button
            style="margin-top: 5px"
            type="warning"
            size="mini"
            @click="setfastPaiBan"
            >快速排班</el-button
          >
          <el-button
            style="
              margin-top: 5px;
              background: #2ac100;
              color: aliceblue;
              border: 0px;
            "
            size="mini"
            @click="setPaiBanTime"
            >排班时间</el-button
          >
          <el-button
            style="margin-top: 5px"
            size="mini"
            @click="setPai"
            type="primary"
            plain
            >设置本月排班</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="pageConBox">
      <el-table
        :data="tableData"
        id="myTable"
        ref="myTable"
        @cell-click="handlerCellClickNew"
        @cell-mouse-enter="handlerMousemoveNew"
        empty-text="当前月份暂未设置排班,请点击设置本月排班"
      >
        <el-table-column>
          <el-table-column label="员工" width="90px">
            <template slot-scope="scope">
              <div>
                <el-tooltip
                  class="item"
                  effect="dark"
                  placement="bottom-start"
                  :content="scope.row.inShopName"
                >
                  <div class="changeTxt" v-if="scope.row.state == 2">调</div>
                </el-tooltip>
                {{ scope.row.staffName }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="职位" prop="staffPosition" width="90px" fixed>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :label="item.weekName"
          v-for="(item, index) in days"
          :key="item.dayId"
        >
          <!-- 0未排班；1早班；2晚班；3通班；4休息；5半天假；6调店 -->
          <el-table-column
            width="50px"
            :label="item.dayId + ''"
            prop="daysSchedule"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.daysSchedule[index].timesId == '0'">
                <p
                  :class="
                    scope.row.daysSchedule[index].canChange == false ? 'bg' : ''
                  "
                >
                  {{ scope.row.daysSchedule[index].timesId == "0" ? "" : "" }}
                </p>
              </div>
              <div
                :class="[
                  scope.row.daysSchedule[index].timesId == 1 ? 'active1' : '',
                ]"
                v-if="scope.row.daysSchedule[index].timesId == '1'"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :disabled="!scope.row.daysSchedule[index].remark"
                  :content="scope.row.daysSchedule[index].remark"
                  placement="bottom-start"
                >
                  <p style="width: 20px">
                    {{
                      scope.row.daysSchedule[index].timesId == "1" ? "早" : ""
                    }}
                  </p>
                </el-tooltip>
              </div>
              <div
                :class="[
                  scope.row.daysSchedule[index].timesId == '2' ? 'active2' : '',
                ]"
                v-if="scope.row.daysSchedule[index].timesId == '2'"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :disabled="!scope.row.daysSchedule[index].remark"
                  :content="scope.row.daysSchedule[index].remark"
                  placement="bottom-start"
                >
                  <p style="width: 20px">
                    {{
                      scope.row.daysSchedule[index].timesId == "2" ? "晚" : ""
                    }}
                  </p>
                </el-tooltip>
              </div>
              <div
                :class="[
                  scope.row.daysSchedule[index].timesId == '3' ? 'active3' : '',
                ]"
                v-if="scope.row.daysSchedule[index].timesId == '3'"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :disabled="!scope.row.daysSchedule[index].remark"
                  :content="scope.row.daysSchedule[index].remark"
                  placement="bottom-start"
                >
                  <p style="width: 20px">
                    {{
                      scope.row.daysSchedule[index].timesId == "3" ? "通" : ""
                    }}
                  </p>
                </el-tooltip>
              </div>
              <div
                :class="[
                  scope.row.daysSchedule[index].timesId == '4' ? 'active4' : '',
                ]"
                v-if="scope.row.daysSchedule[index].timesId == '4'"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :disabled="!scope.row.daysSchedule[index].remark"
                  :content="scope.row.daysSchedule[index].remark"
                  placement="bottom-start"
                >
                  <p style="width: 20px">
                    {{
                      scope.row.daysSchedule[index].timesId == "4" ? "休" : ""
                    }}
                  </p>
                </el-tooltip>
              </div>
              <div
                :class="[
                  scope.row.daysSchedule[index].timesId == '5' ? 'active5' : '',
                ]"
                v-if="scope.row.daysSchedule[index].timesId == '5'"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  v-if="scope.row.daysSchedule[index].remark"
                  :disabled="!scope.row.daysSchedule[index].remark"
                  :content="scope.row.daysSchedule[index].remark"
                  placement="bottom-start"
                >
                  <p style="width: 20px">
                    {{
                      scope.row.daysSchedule[index].timesId == "5" ? "半天" : ""
                    }}
                  </p>
                </el-tooltip>
              </div>
              <div
                :class="[
                  scope.row.daysSchedule[index].timesId == '6' ? 'active6' : '',
                ]"
                v-if="scope.row.daysSchedule[index].timesId == '6'"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  :disabled="!scope.row.daysSchedule[index].remark"
                  :content="scope.row.daysSchedule[index].remark"
                  placement="bottom-start"
                >
                  <p style="width: 20px">
                    {{
                      scope.row.daysSchedule[index].timesId == "6" ? "调" : ""
                    }}
                  </p>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <!-- 排班时间 -->
    <el-dialog
      title="排班时间"
      :visible.sync="paiBanTimeState"
      width="30%"
      center
    >
      <div class="boxView">
        <div v-for="item in workTimes" :key="item.id">
          <span class="boxSpan">{{ item.timesName }}</span>
          <el-time-select
            style="width: 40%; margin-bottom: 10px; margin-right: 10px"
            v-model="item.startTime"
            :picker-options="{
              start: '08:30',
              step: '00:30',
              end: '22:00',
            }"
            :disabled="disabled"
            placeholder="开始时间"
          >
          </el-time-select>
          <el-time-select
            style="width: 40%; margin-bottom: 10px"
            v-model="item.endTime"
            :picker-options="{
              start: '08:30',
              step: '00:30',
              end: '22:00',
            }"
            value-format="HH:mm"
            format="HH:mm"
            :disabled="disabled"
            placeholder="结束时间"
          >
          </el-time-select>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="paiBanTimeState = false">取 消</el-button>
        <el-button type="primary" @click="updateWorkTimes">保存</el-button> -->
      </span>
    </el-dialog>
    <!-- 快速排班 -->
    <el-dialog
      title="快速排班"
      :visible.sync="fastPaiBanState"
      width="30%"
      center
    >
      <div class="boxView">
        <span class="boxSpan">排班类型:</span>
        <el-select
          v-model="timesId"
          placeholder="请选择"
          @change="changeTimesId(timesId)"
        >
          <!-- 0未排班；1早班；2晚班；3通班；4休息；5半天假；6调店 -->
          <el-option
            v-for="item in [
              { label: '早班', value: 1 },
              { label: '晚班', value: 2 },
              { label: '通班', value: 3 },
              { label: '休息', value: 4 },
              { label: '半天假', value: 5 },
              { label: '调店', value: 6 },
            ]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="boxView" v-if="shopTime">
        <span class="boxSpan">上班时间:</span>
        <el-time-select
          style="width: 40%; margin-bottom: 10px; margin-right: 10px"
          v-model="startTime"
          :picker-options="{
            start: '08:30',
            step: '00:30',
            end: '22:00',
          }"
          placeholder="开始时间"
        >
        </el-time-select>
        <el-time-select
          style="width: 40%; margin-bottom: 10px"
          v-model="endTime"
          :picker-options="{
            start: '08:30',
            step: '00:30',
            end: '22:00',
          }"
          value-format="HH:mm"
          format="HH:mm"
          placeholder="结束时间"
        >
        </el-time-select>
      </div>
      <div class="boxView" v-if="shopState">
        <span class="boxSpan">调店门店:</span>
        <el-select
          size="small"
          class="select"
          v-model="moveShopId"
          placeholder="请选择"
        >
          <!--  -->
          <el-option
            :disabled="item.shop_id == shopId"
            v-for="item in shopList"
            :key="item.shop_id"
            :label="item.shop_name"
            :value="item.shop_id"
          >
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="fastPaiBanState = false">取 消</el-button>
        <el-button type="primary" @click="updateSchedule">保存</el-button>
      </span>
    </el-dialog>
    <!-- 设置本月排班 -->
    <div v-if="drawerAdd_state">
      <drawerAdd @submit="submit_drawerAdd"></drawerAdd>
    </div>
  </div>
</template>

<script>
import drawerAdd from "./drawer_add.vue";
export default {
  components: { drawerAdd },
  data() {
    return {
      disabled: true,
      shopState: false,
      shopTime: false,
      // 日期和周数组
      days: [],
      currDate: "",
      drawerAdd_state: false,
      paiBanTimeState: false,
      // fast
      fastPaiBanState: false,
      value: "",
      endTime: "",
      startTime: "",
      workTimes: [
        {
          timesId: 1,
          timesName: "早班",
          endTime: "",
          startTime: "",
        },
        {
          timesId: 2,
          timesName: "晚班",
          endTime: "",
          startTime: "",
        },
        {
          timesId: 3,
          timesName: "通班",
          endTime: "",
          startTime: "",
        },
      ],
      timesId: "", //排班类型
      tableData: [],
      shopId: this.$store.state.shopId,
      shopList: [],
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      isClick: false, // 鼠标是否单击过
      currentCell: null, // 当前单击的cell对象
      isLongClick: false, // 鼠标是否长按不松开
      selectCllList: [], // 存放滑动时选中的cell  // 滑动后在在进行单击的时候要清空
      select: [], // 拖动的最终值
      selectCellList: [],
      selectDataList: [], // 拖动的最终值
      staffPositionList: [], //职位数组
      staffNameList: [], //员工姓名数组
      items: [],
      moveShopId: "", //调店id
      canChange: true, //能否更改排班
    };
  },
  created() {
    // 排班月份
    if (!this.currDate) {
      this.currDate = new Date();
      sessionStorage.setItem("pBMonth", this.$public.FTimeStr10(this.currDate));
    }
    this.getShopData();
    this.getWorkTimes();
    this.getShopSchedule();
    this.$nextTick(function () {
      let temp = document.getElementById("myTable");
      temp.addEventListener("mousedown", this.handlerMousedown); // 鼠标按下事件
      temp.addEventListener("mouseup", this.handlerMouseup); // 鼠标按下抬起事件
    });
  },
  watch: {
    // select(n) {
    //   console.log("拖动的最终值", n);
    // },
  },
  mounted() {},
  methods: {
    //获取门店列表
    getShopData() {
      this.$http
        .get(process.env.VUE_APP_Url2 + "api/CompanyInfo/shop/list")
        .then((res) => {
          if (res.code == 0) {
            // console.log('门店', res.data);
            this.shopList = res.data;
          }
        });
    },
    // 同步员工
    syncStaff() {
      var d = new Date(this.currDate);
      let params = {
        shopId: this.$store.state.shopId,
        shopName: this.$public.getShopNameById(this.$store.state.shopId),
        year: d.getFullYear(),
        month: d.getMonth() + 1,
      };
      // console.log('params',params);
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/syncStaff",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("同步", res);

            // this.$router.go(0);
            this.getShopSchedule();
          }
        });
    },
    selectListAdd(
      days,
      staffId,
      staffName,
      staffPosition,
      row,
      column,
      cell,
      event
    ) {
      this.selectDataList.push({ days, staffId, staffName, staffPosition });
      this.selectCellList.push({ row, column, cell, event });
      cell.style = "background-color:#f5882a";
    },
    selectListRemove(
      days,
      staffId,
      staffName,
      staffPosition,
      row,
      column,
      cell,
      event
    ) {
      // console.log(days[0]);
      let index = this.selectCellList.findIndex((item) => {
        return item.cell == cell;
      });
      this.selectCellList.splice(index, 1);
      this.selectDataList.splice(index, 1);
      cell.style = "background-color:#fff";
    },
    // 快速排班
    updateSchedule() {
      if (this.timesId == "") {
        this.$message({
          type: "error",
          message: "请选择排班类型",
        });
        return;
      }
      if (this.timesId == 5 && this.startTime == "") {
        this.$message({
          type: "error",
          message: "请选择开始时间",
        });
        return;
      }
      if (this.timesId == 5 && this.endTime == "") {
        this.$message({
          type: "error",
          message: "请选择结束时间",
        });
        return;
      }
      if (this.timesId == 6 && this.moveShopId == "") {
        this.$message({
          type: "error",
          message: "请选择调拨门店",
        });
        return;
      }
      var d = new Date(this.currDate);
      if (this.startTime[0] == "0") {
        this.startTime = this.startTime.slice(1);
      }
      if (this.endTime[0] == "0") {
        this.endTime = this.endTime.slice(1);
      }
      let params = {
        shopId: this.$store.state.shopId,
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        items: this.items,
        timesId: this.timesId,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      if (this.timesId == 6) {
        params.moveShopId = this.moveShopId;
        params.moveShopName = this.$public.getShopNameById(this.moveShopId);
      }
      // console.log(params);
      let loading = this.$loading();
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/updateSchedule",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.selectCellList.forEach((item) => {
              item.cell.style = "background-color:#fff";
            });
            this.selectCellList = [];
            this.selectDataList = [];
            this.getShopSchedule();
            this.fastPaiBanState = false;
          }
        });
    },
    // 获取员工信息的数组
    getArr(arr) {
      let newArray = [];
      arr.forEach((item) => {
        const index = newArray.findIndex(
          (child) => child.staffId === item.staffId
        );
        console.log(index);
        if (index >= 0) {
          newArray[index].days.push(item.days[0]);
        } else {
          item.days = [item.days[0]];
          newArray.push(item);
        }
      });
      // console.log("newArray", newArray);
      return newArray;
    },
    // 设置快速排班
    setfastPaiBan() {
      console.log("数组", this.selectDataList);
      if (this.selectDataList.length) {
        this.items = this.getArr(this.selectDataList);
      }
      console.log("this.items", this.items);
      // 单击只有一个单元格
      if (this.items.length) {
        this.fastPaiBanState = true;
      } else {
        this.$message.error("请选择员工");
        return;
      }
    },
    handlerCellClickNew(row, column, cell, event) {
      row.daysSchedule.forEach((item) => {
        if (item.dayId == parseInt(column.label)) {
          if (!item.canChange) {
            this.canChange = false;
            // console.log("item", item);
          } else {
            this.canChange = true;
          }
        }
      });
      if (!this.canChange) {
        this.$message.error("请重新选择员工");
        this.items = [];
        return;
      }
      // // 左侧员工 职位不能变色
      if (
        !this.staffNameList.includes(event.target.innerText) &&
        !this.staffPositionList.includes(event.target.innerText)
      ) {
        if (!this.selectCellList.find((item) => item.cell === cell)) {
          this.selectListAdd(
            [parseInt(column.label)],
            row.staffId,
            row.staffName,
            row.staffPosition,
            row,
            column,
            cell,
            event
          );
        } else {
          this.selectListRemove(
            [parseInt(column.label)],
            row.staffId,
            row.staffName,
            row.staffPosition,
            row,
            column,
            cell,
            event
          );
        }
      }
    },

    //  鼠标点击按下事件
    handlerMousedown(e) {
      //  若果上一次是滑动则清空上一次存放的cell
      if (this.selectCllList.length) {
        this.selectCllList.forEach((item) => {
          item.style = "background:#fff";
        });
      }
      this.isLongClick = true;
      if (
        !this.staffNameList.includes(e.target.innerText) &&
        !this.staffPositionList.includes(e.target.innerText)
      ) {
        if (this.currentCell) {
          this.$nextTick(() => {
            this.currentCell.style = "background:#fff";
          });
        }
        this.$nextTick(() => {
          this.currentCell = e;
          e.style = "background:red";
        });
      }
    },
    //  鼠标点击抬起事件
    handlerMouseup(e) {
      this.isLongClick = false;
      console.log("鼠标抬起", e);
    },
    handlerMousemoveNew(row, column, cell, event) {
      if (
        !this.staffNameList.includes(event.target.innerText) &&
        !this.staffPositionList.includes(event.target.innerText)
      ) {
        if (this.isLongClick) {
          if (!this.selectCellList.find((item) => item.cell === cell)) {
            this.selectListAdd(
              [parseInt(column.label)],
              row.staffId,
              row.staffName,
              row.staffPosition,
              row,
              column,
              cell,
              event
            );
          } else {
            this.selectListRemove(
              [parseInt(column.label)],
              row.staffId,
              row.staffName,
              row.staffPosition,
              row,
              column,
              cell,
              event
            );
          }
        }
      }
    },

    // 改变排班类型
    changeTimesId(a) {
      if (a == 6) {
        this.shopState = true;
      } else {
        this.shopState = false;
      }
      if (a == 5) {
        this.shopTime = true;
      } else {
        this.shopTime = false;
      }
    },
    // 获取排班信息
    getShopSchedule() {
      var d = new Date(this.currDate);
      let params = {
        shopId: this.$store.state.shopId,
        year: d.getFullYear(),
        month: d.getMonth() + 1,
      };
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/shopSchedule",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("员工排班信息", res.data);
            this.tableData = res.data.data;
            this.days = res.data.days;
            res.data.data.forEach((item) => {
              this.staffNameList.push(item.staffName);
            });
            res.data.data.forEach((item) => {
              this.staffPositionList.push(item.staffPosition);
            });
          }
        });
    },
    // 添加/修改班次信息
    updateWorkTimes() {
      let loading = this.$loading();
      let params = {
        shopId: this.$store.state.shopId,
        shopName: this.$public.getShopNameById(this.$store.state.shopId),
        workTimes: this.workTimes,
      };
      this.$http
        .post(
          process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/updateWorkTimes",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.paiBanTimeState = false;
            this.$router.go(0);
            this.getShopSchedule();
            this.$message({
              message: "设置成功",
              type: "success",
            });
          }
        });
    },
    // 获取班次信息
    getWorkTimes() {
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/shopWorkTimes", {
          shopId: this.$store.state.shopId,
        })
        .then((res) => {
          if (res.code == 0) {
            this.workTimes = res.data.workTimes;
          }
        });
    },

    // 设置排班时间
    setPaiBanTime() {
      this.paiBanTimeState = true;
    },
    setPai() {
      var d = new Date(this.currDate);
      let params = {
        shopId: this.$store.state.shopId,
        shopName: this.$public.getShopNameById(this.$store.state.shopId),
        year: d.getFullYear(),
        month: d.getMonth() + 1,
      };
      // console.log('params',params);
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_AppAdmin + "/api/ShopSchedule/syncStaff",
          params
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            // console.log("同步", res);
            this.getShopSchedule();
            this.drawerAdd_state = true;
          }
        });
    },
    // 设置本月排班
    submit_drawerAdd() {
      this.drawerAdd_state = false;
      this.getShopSchedule();
    },
    //排班月份
    changePicker(val) {
      sessionStorage.setItem("pBMonth", this.$public.FTimeStr10(val));
      this.refresh++;
      this.getShopSchedule();
      if (!this.tableData.length) {
        console.log("没有同步");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.page {
  font-size: 12px;
  .boxView {
    margin: 10px;
    .boxSpan {
      display: inline-block;
      margin-right: 20px;
    }
  }
  .dialog-footer {
    .el-button:nth-child(1) {
      width: 150px;
      background: #d6d6d6;
      color: white;
      border: 0px;
    }
    .el-button:nth-child(2) {
      width: 150px;
      color: white;
      border: 0px;
      background: #f5882a;
    }
  }
}

//早班
.active1 {
  background: #e0f1ff;
  border-left: 4px solid #0081ea;
  padding-left: 5px;
}
//晚班
.active2 {
  background: #dbffd7;
  border-left: 4px solid #11bb00;
  padding-left: 5px;
}
//通班
.active3 {
  background: #ffd4d4;
  border-left: 4px solid #ea0000;
  padding-left: 5px;
}
//休息
.active4 {
  background: #ffc390;
  border-left: 4px solid #f5882a;
  padding-left: 5px;
}
//半天班
.active5 {
  background: #fff8c1;
  border-left: 4px solid #bba500;
  padding-left: 5px;
}
//调店
.active6 {
  background: #e9d8ff;
  border-left: 4px solid #6700ea;
  padding-left: 5px;
}
// 调店
.changeTxt {
  display: inline-block;
  color: #6700ea;
  background: #e9d8ff;
  width: 20px;
  height: 20px;
  padding-left: 5px;
  line-height: 20px;
  font-size: 12px;
}
.bg {
  height: 20px;
  background: #f1f0f3 !important;
}
</style>